import React from "react";
import {Route, Routes} from "react-router-dom";
import Watch from "../pages/Watch";
import Home from "../pages/Home";
import Client from "../pages/Client";
import Statistic from "../pages/statisticsPage";
import FAQ from "../pages/FAQ";
import SessionTable from "../pages/SessionTable";
import RoomTable from "../pages/RoomTable";
import AdminList from "../pages/AdminList";
import UserList from "../pages/UserList";
import DeleteSession from "../pages/DeleteSession";
import Instruction from "../pages/Instruction";
import WatchGenerate from "../pages/WatchGenerate";
import PersonalPage from "../pages/PersonalPage";
import RequireAccess from "./RequireAccess";
import RoomGenerate from "../pages/RoomGenerate";
import ClientGenerate from "../pages/ClientGenerate";
import RoomSessionTable from "../pages/RoomSessionTable";
import LogTable from "../pages/LogTable";
import LessonList from "../pages/LessonList";
import SimplifedTable from "../pages/SimplifiedTable";
import ScreencastTextLog from "../pages/ScreencastTextLog";
import PluginSettings from '../pages/PluginSettings';
import LDAPSync from '../components/LDAPSync';


export default function RoutesList() {
    /*
        - RequireAccess - for private access pages (auth needed)
     */
    return (
        <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/mypage" element={<PersonalPage />} />
            <Route path="/faq" element={<FAQ/>}/>
            <Route path="/ldap" element={<RequireAccess path="/ldap" component={LDAPSync}/>}/>
            <Route path="/generateSession" element={<RequireAccess path="/generateSession" component={ClientGenerate}/>}/>
            <Route path="/generateRoom" element={<RequireAccess path="/generateRoom" component={RoomGenerate}/>}/>
            <Route path="/generateSession/:room" element={<RequireAccess path="/generateSession" component={ClientGenerate}/>} />
            <Route path="/instruction" element={<RequireAccess path="/instruction" component={Instruction}/>} />
            <Route path="/generateSession/client/:token" element={<RequireAccess path="/client/:token" component={Client}/>} />
            <Route path="/teach/:token" element={<RequireAccess path="/teach/:token" component={Watch}/>} />
            <Route path="/lessonList" element={<RequireAccess path="/lessonList" component={LessonList}/>} />
            <Route exact path="/teach" element={<RequireAccess path="/teach" component={WatchGenerate}/>} />
            <Route exact path="/table/other" element={<RequireAccess path="/table/other" component={SessionTable}/>} />
            <Route exact path="/table/:token" element={<RequireAccess path="/table/:token" component={RoomSessionTable}/>} />
            <Route exact path="/table" element={<RequireAccess path="/table" component={RoomTable}/>} />
            <Route exact path='/table/simplifiedTable' element={<RequireAccess path="/simplifiedTable" component={SimplifedTable}/>}/>
            <Route path="/admin/plugin-settings" element={<RequireAccess path="/admin" adminOnly component={PluginSettings}/>} />
            <Route exact path="/admin/admins" element={<RequireAccess path="/admin" adminOnly component={AdminList}/>} />
            <Route exact path="/admin/users" element={<RequireAccess path="/admin" component={UserList}/>} />
            <Route exact path="/statistic" element={<RequireAccess path="/statistic" component={Statistic}/>} />
            <Route exact path="/deleteSession" element={<RequireAccess path="/deleteSession" component={DeleteSession}/>} />
            <Route exact path="/logTable" element={<RequireAccess path="/logTable" component={LogTable}/>}/>
            <Route exact path="/table/screencastText/:token" element={<RequireAccess path="/table/screencastText/:token" component={ScreencastTextLog}/>}/>
        </Routes>
    );
}
